module.exports = __webpack_public_path__ + "img/user-media.7954ee1e.svg";